import React, { createContext, useContext, useState, useEffect } from "react";
import AuthService from "../service/AuthService";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({full_name : "rakor"});

  useEffect(() => {
    setUser(AuthService.getUserInfo());
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
